// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"381f62a5","703":"46f4e3db"}[chunkId] + ".chunk.js";
};